export default String.raw`
{% assign type = include -%}
{% if type == 'complaint' -%}
    {% assign complaint = true -%}
    {% assign openFormButtonName = translations.Complain -%}
    {% assign action = 'Order/ComplaintAdd' -%}
    {% assign formName = translations.ComplaintForm -%}
    {% assign postButtonName = translations.SendComplaint -%}
    {% assign successTitle = translations.ComplaintSuccessTitle -%}
    {% assign successInfo = translations.ComplaintSuccessInfo -%}
{% else -%}
    {% assign complaint = false -%}
    {% assign openFormButtonName = translations.Return -%}
    {% assign action = 'Order/ReturnAdd' -%}
    {% assign formName = translations.ReturnForm -%}
    {% assign postButtonName = translations.SendReturn -%}
    {% assign successTitle = translations.ReturnSuccessTitle -%}
    {% assign successInfo = translations.ReturnSuccessInfo -%}
{% endif -%}

<div class="message-popup-background complaint-popup-js hidden-js container-to-hide-js stop-propagation-js">
	<div class="change-data-container complaint add-complaint-form-js">
        <div class="data-form__header">
            {{ formName }}
            <button class="close-button hide-container-js closing-modal-js" aria-label="{{ translations.Close }}">
                <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
            </button>
        </div>
        <div class="form-js">
            <input type="hidden" name="__action" value="{{ action }}">
            <input type="hidden" name="orderId" value="{{ order.Id }}">
            <input type="hidden" name="no" value="{{ product.No }}">
            <div class="product-container">
                <div class="image">
                    {% if product.ImageId != -1 or product.Image != null -%} {{ product | Img: 'small' }} {% else -%} <svg width="40" height="40"><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use></svg> {% endif -%}
                </div>
                <div class="info">
                    <div class="name">
                        {% if product.Url -%}
                            <a href="{{ page.BaseHref }}{{ product.Url }}">
                        {% endif -%}
                            {% if type == 'set-return' -%}
                                {{ product.SetName }}
                            {% else -%}
                                {{ product.NameNoHtml }}
                            {% endif -%}
                        {% if product.Url -%}
                            </a>
                        {% endif -%}
                    </div>
                    {% if type != 'set-return' -%}
                        <div class="description">
                            {% if config.Products.ShowCode -%}
                                <div class="code">{{ product.Code }}</div>
                            {% endif -%}
                            {% if product.Description != "" -%}
                                <ul>
                                    {% assign descriptionLength = product.Description | Size | Minus: 2 -%}
                                    {% assign description = product.Description | Slice: 0, descriptionLength | Split: ';' -%}
                                    {% for attribute in description -%}
                                        {% assign attrName = attribute | Split: ':' | First -%}
                                        {% assign attrValue = attribute | Split: ':' | Last -%}
                                        <li>{{ attrName }}: {{ attrValue }}</li>
                                    {% endfor -%}
                                </ul>
                            {% endif -%}
                        </div>
                    {% endif -%}
                </div>
            </div>
            {% if type != 'set-return' -%}
                <div class="amount-stepper-container amount-stepper-container-js" {% if product.Quantity < 2 -%}data-quantity="{{ product.Quantity | Normalize }}"{% endif -%}>
                    <span class="amount-stepper-container__label">{{ translations.Quantity }}:</span>
                    {% if product.Quantity > 1 -%}
                        {% include 'partials/product/amount-stepper.html' with product -%}
                        <span>
                            {% if product.SaleUnit -%}
                                {{product.SaleUnit}}
                            {% else -%}
                                {{product.Unit}}
                            {% endif -%}
                        </span>
                    {% else -%}
                        {{ product.Quantity | Normalize }}
                        {% if product.SaleUnit -%}
                            {{product.SaleUnit}}
                        {% else -%}
                            {{product.Unit}}
                        {% endif -%}
                    {% endif -%}
                </div>
            {% endif -%}
            {% if complaint -%}
                    <div class="form__input-wrapper">
                        <label for="defectId" class="form__input-info input-info-js">{{ translations.ComplaintCause }} <span class="required">*</span></label>
                        <select id="defectId" class="form__input-value input-value-js" name="defectId">
                            {% for defect in config.Complaints.Defects -%}
                            <option {% if defect.Id == config.Complaints.Defects[0].Id -%} selected {% endif -%} value="{{ defect.Id }}">
                                {{ defect.Name }}
                            </option>
                            {% endfor -%}
                        </select>
                    </div>
                <div class="form__input-wrapper">
                    <label for="defectDate" class="form__input-info input-info-js on-label">{{ translations.DefectDate }} <span class="required">*</span></label>
                    <input id="defectDate" class="form__input-value input-value-js" type="date" name="defectDate" value="{{ config.Now | Date:'yyyy-MM-dd' }}" min="{{ order.Date | Date:'yyyy-MM-dd' }}" max="{{ config.Now | Date:'yyyy-MM-dd' }}" >
                </div>
                <div class="form__input-wrapper">
                    <label for="requestId" class="form__input-info input-info-js">{{ translations.ChooseRequest }} <span class="required">*</span></label>
                    <select id="requestId" class="form__input-value input-value-js" name="requestId">
                        {% for request in config.Complaints.Requests -%}
                            <option {% if request.Id == config.Complaints.Defects[0].Id -%} selected {% endif -%} value="{{ request.Id }}">
                                {{ request.Name }}
                            </option>
                        {% endfor -%}
                    </select>
                </div>
            {% else -%}
                {% assign returnTypes = config.Complaints.Returns | Size -%}
                {% if returnTypes > 1 -%}
                    <div class="form__input-wrapper">
                        <label for="returnId" class="form__input-info input-info-js">{{ translations.ChooseReturn }} <span class="required">*</span></label>
                        <div>
                            <select id="returnId" class="form__input-value input-value-js" name="returnId">
                                {% for return in config.Complaints.Returns -%}
                                    <option {% if return.Id == config.Complaints.Returns[0].Id -%} selected {% endif -%} value="{{ return.Id }}">
                                        {{ return.Name }}
                                    </option>
                                {% endfor -%}
                            </select>
                        </div>
                    </div>
                {% endif -%}
                <div class="form__input-wrapper account-number-wrapper-js">
                    <label for="accountNumber" class="form__input-info input-info-js">{{ translations.Com_BankAccountNumber }} <span class="required">*</span></label>
                    <input id="accountNumber" class="form__input-value input-value-js" type="text" name="accountNumber" maxlength="50" required>
                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
                </div>
            {% endif -%}
            <div class="form__input-wrapper">
                {% assign maxLength = 500 -%}
                <label for="complaint-textarea" class="form__input-info input-info-js">{{ translations.AdditionalInfo }}</label>
                <div class="scrollable"></div>
                <textarea  id="complaint-textarea" class="form__input-value input-value-js" maxlength="500" name="message"></textarea>
                <div class="characters-counter characters-counter-js"></div>
                <div class="characters-length characters-length-js">{{ translations.Com_MaxFieldSize | Format: maxLength }}</div>
            </div>
            {% if config.Complaints.AttachmentsEnabled -%}
            <div class="file-attachements-wrapper">
                <label for="complaint-file" class="file add-attachement-in-complaint-label-js"><svg width="24" height="24"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use></svg> {{ translations.AddAttachement }}  <span>(Max. {{ config.Complaints.AttachmentsMaxCount }})</span></label>
                {% capture maxSize -%}{{config.Complaints.AttachmentMaxSize}}B{% endcapture -%}
                {% capture filePrefix -%}file-{{ order.Id }}-{{ product.No }}-{{ type }}{% endcapture -%}
                {% for i in (1..config.Complaints.AttachmentsMaxCount) -%}
                    <div class="file-container hidden-js">
                        <label for="{{ filePrefix }}-{{ forloop.index }}" class="file">
                            <input id="{{ filePrefix }}-{{ forloop.index }}" class="add-attachement-in-complaint-js hidden-js" type="file" name="file" accept="{{ config.Complaints.AttachmentExtensions }}" data-file-size="{{ config.Complaints.AttachmentMaxSize }}" data-size-exceeded="{{ translations.Com_FileSizeExceeded | Format: maxSize }}" data-invalid-file="{{ translations.Com_InvalidFile | Format: config.Complaints.AttachmentExtensions }}">
                            <i class="icon-js">
                                <svg width="24" height="24" class="svgIcon">
                                    <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use>
                                </svg>
                            </i>
                            <span class="input-text-js"></span>
                            <button class="close-button clear-file-input-js" aria-label="{{ translations.Close }}">
                                <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                            </button>
                        </label>
                    </div>
                {% endfor -%}
            </div>
            {% endif -%}
            <div class="required-fields"><span class="required">*</span> {{ translations.RequiredFields }}</div>
            <div class="buttons-container short">
                <button class="pure-button hide-container-js closing-modal-js">
                    {{ translations.Cancel }}
                </button>
                <button class="primary-action-button send-complaint-js">
                    {{ postButtonName }}
                </button>
            </div>
        </div>
        <div class="success-message-js hidden-js">
            {% if complaint -%}
                <span>{{ successInfo }}</span>
            {% else -%}
                <div class="data-form__header return-success__header">
                    <span></span>
                    <button class="close-button hide-container-js closing-modal-js" aria-label="{{ translations.Close }}">
                        <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                    </button>
                </div>
                <div class="return-success__icon">
                    <svg aria-hidden="true" width="48" height="48" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use></svg>
                </div>
                <div class="return-success__title">{{ successTitle }}</div>
                <div class="return-success__subtitle">{{ successInfo }}</div>

                {% assign complaintMailAddress = '' -%}
                {% if customer.Email and customer.Email != '' -%}
                    {% assign complaintMailAddress = customer.Email -%}
                {% elsif order.Customer.Email and order.Customer.Email != '' -%}
                    {% assign complaintMailAddress = order.Customer.Email -%}
                {% elsif usr.Authenticated == false and customer-profile.Order.Customer.Email and customer-profile.Order.Customer.Email != ''-%}
                    {% assign complaintMailAddress = customer-profile.Order.Customer.Email -%}
                {% elsif order.Customer.InvoiceAddress.Email and order.Customer.InvoiceAddress.Email != '' -%}
                    {% assign complaintMailAddress = order.Customer.InvoiceAddress.Email -%}
                {% endif -%}

                {% if complaintMailAddress != '' -%}
                    <div class="return-success__email-box">
                        <svg aria-hidden="true" width="20" height="20" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use></svg>
                        <div>
                            <div>{{ translations.Com_ConfirmationSentTo }}</div>
                            <strong>{{ complaintMailAddress }}</strong>
                        </div>
                    </div>
                {% endif -%}
                <div class="return-success__steps-title">{{ translations.Com_NextSteps }}</div>
                <ol class="return-success__steps">
                    <li>{{ translations.Com_PackProducts }}</li>
                    <li>
                        {{ translations.Com_SendPackageTo }}
                        {% if config.Shop.Address.Street != '' -%} {{ config.Shop.Address.Street }}{% endif -%}
                        {% if config.Shop.Address.StreetNo != '' -%} {{ config.Shop.Address.StreetNo }}{% endif -%}
                        {% if config.Shop.Address.UnitNo != '' -%}/{{ config.Shop.Address.UnitNo }}{% endif -%}
                        {% if config.Shop.Address.ZipCode != '' or config.Shop.Address.City != '' -%}, {{ config.Shop.Address.ZipCode }} {{ config.Shop.Address.City }}{% endif -%}
                    </li>
                    <li>{{ translations.Com_RefundAfterReceive }}</li>
                </ol>
                <div class="buttons-container short">
                    <button class="primary-action-button hide-container-js closing-modal-js">
                        {{ translations.Close }}
                    </button>
                </div>
            {% endif -%}
        </div>
    </div>
</div>
`